import { useState, useEffect } from 'react'
import { Grid } from '@material-ui/core'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import Button from '@material-ui/core/Button'
import TItemIndividual from '../TItemIndividual'
import TItemGrupal from '../TItemGrupal'
import { useDispatch } from 'react-redux'
import { obtenerItemsIndividual, obtenerItemsGrupal } from '../../../ducks/finanzasDuck'
import BackDrop from '../../../global/BackDrop'
const ItemsPagar = () => {
    const [tipoPago, setTipoPago] = useState(true)
    const [load, setLoad] = useState(false)
    const dispatch = useDispatch()
    const onClick = () => {
        setTipoPago(!tipoPago)
    }

    useEffect(() => {
        setLoad(true)
        dispatch(obtenerItemsIndividual()).then(Response => {
            setLoad(false)
        })
        setLoad(true)
        dispatch(obtenerItemsGrupal()).then(Response => {
            setLoad(false)
        })
    }, [dispatch])

    return (
        <div>
            <Grid container>
                <Grid item xs={12}>
                    <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "10px" }}>
                        <h3>Tipo de pago</h3>
                        <ButtonGroup disableElevation variant="contained" color="primary">
                            <Button onClick={onClick} color={tipoPago ? 'secondary' : 'default'} >Individual</Button>
                            <Button onClick={onClick} color={!tipoPago ? 'secondary' : 'default'} >Grupal</Button>
                        </ButtonGroup>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    {
                        (tipoPago) &&
                        <TItemIndividual />
                    }

                    {
                        (!tipoPago) &&
                        <TItemGrupal />
                    }
                </Grid>
            </Grid>
            <BackDrop open={load} />
        </div>
    )
}
export default ItemsPagar